import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IConsultantCianChatsState {
  requestStatus: 'initial' | 'loading' | 'finished';
  isLoading: boolean;
  isError: boolean;
  isErrorPopupOpened: boolean;
  isEnabled: boolean;
  isOpened: boolean;
  chatId: string | null;
  isAutorisationPopupOpened: boolean;
}

const initialState: IConsultantCianChatsState = {
  requestStatus: 'initial',
  chatId: null,
  isLoading: false,
  isError: false,
  isErrorPopupOpened: false,
  isEnabled: false,
  isOpened: false,
  isAutorisationPopupOpened: false,
};

export const consultantCianChatSlice = createSlice({
  name: 'consultantCianChat',
  initialState,
  reducers: {
    openAutorisationMotivationPopup: state => {
      state.isOpened = false;
      state.isAutorisationPopupOpened = true;
    },
    closeAutorisationMotivationPopup: state => {
      state.isOpened = false;
      state.isAutorisationPopupOpened = false;
    },
    openChat: (state, action: PayloadAction<string>) => {
      state.chatId = action.payload;
      state.isOpened = true;
      state.isLoading = false;
      state.isAutorisationPopupOpened = false;
    },
    closeChat: state => {
      state.isOpened = false;
      state.isAutorisationPopupOpened = false;
    },
    setChatLoading: state => {
      state.isLoading = true;
    },
    openErrorMessage: state => {
      state.isError = true;
      state.isErrorPopupOpened = true;
      state.isLoading = false;
    },
    closeErrorMessage: state => {
      state.isErrorPopupOpened = false;
      state.isAutorisationPopupOpened = false;
    },
  },
});

export const {
  reducer: consultantCianChatReducer,
  actions: {
    openAutorisationMotivationPopup,
    closeAutorisationMotivationPopup,
    openChat,
    closeChat,
    setChatLoading,
    openErrorMessage,
    closeErrorMessage,
  },
} = consultantCianChatSlice;
